import AuthRequired from "../utils/AuthRequired";

import Dashboard from "../views/inventory/dashboard/Dashboard";

// products
import ProductsList from "../views/inventory/products/products/ProductsList";
import ProductUnitsList from "../views/inventory/products/units/ProductUnitsList";
import ProductModelsList from "../views/inventory/products/models/ProductModelsList";
import ProductBrandsList from "../views/inventory/products/brands/ProductBrandsList";
import ProductCategoriesList from "../views/inventory/products/categories/ProductCategoriesList";

import SuppliersList from "../views/inventory/purchases/suppliers/SuppliersList";

import RequisitionsList from "../views/inventory/requisitions/RequisitionsList";

import UsageList from "../views/inventory/items-usage/UsageList";

// purchase
import ItemsReceivedList from "../views/inventory/purchases/items-recieved/ItemsReceivedList";
import PurchaseOrdersList from "../views/inventory/purchases/purchase-orders/PurchaseOrdersList";
import TransfersList from "../views/inventory/purchases/transfers/TransfersList";

// adjustments
import AdjustmentsList from "../views/inventory/adjustments/adjustments/AdjustmentsList";
import PurchaseReturnsList from "../views/inventory/adjustments/purchase-returns/PurchaseReturnsList";
import TransferReturnsList from "../views/inventory/adjustments/transfer-returns/TransferReturnsList";

// site-information
import FacilitiesList from "../views/inventory/site-information/facilities/FacilitiesList";
import StoresList from "../views/inventory/site-information/stores/StoresList";
import ShelvesList from "../views/inventory/site-information/shelves/ShelvesList";

// reports
import GeneralReportsList from "../views/inventory/reports/general-reports/GeneralReportsList";
import InventoryReportsList from "../views/inventory/reports/inventory-reports/InventoryReportsList";

// settings
import GeneralSettings from "../views/inventory/settings/general-settings/GeneralSettings";
import ApprovalProcess from "../views/inventory/settings/approval-process/ApprovalProcess";
import EmailTemplates from "../views/inventory/settings/email-templates/EmailTemplates";
import Prefixes from "../views/inventory/settings/prefixes/Prefixes";
import ESign from "../views/inventory/settings/esign/ESign";
import Misc from "../views/inventory/settings/misc/Misc";


export default [
    {
        path: "/",
        redirect: '/inventory',
    },
    {
        path: "/inventory",
        component: () => import("../views"),
        beforeEnter: AuthRequired,
        children: [
            {
                path: "/", component: Dashboard,
            },
            {
                path: "/", component: ProductsList,
            },
            {
                path: "products",
                component: () => import("../views/inventory/products"),
                children: [
                    {
                        path: "list", component: ProductsList,
                    },
                    {
                        path: "categories", component: ProductCategoriesList,
                    },
                    {
                        path: "brands", component: ProductBrandsList,
                    },
                    {
                        path: "models", component: ProductModelsList,
                    },
                    {
                        path: "units", component: ProductUnitsList,
                    },
                ]
            },
            {
                path: "requisitions", component: RequisitionsList,
            },
            {
                path: "items-usage", component: UsageList,
            },
            {
                path: "purchases",
                component: () => import("../views/inventory/purchases"),
                children: [
                    {
                        path: "items-received", component: ItemsReceivedList,
                    },
                    {
                        path: "purchase-orders", component: PurchaseOrdersList,
                    },
                    {
                        path: "transfers", component: TransfersList,
                    },
                    {
                        path: "suppliers", component: SuppliersList,
                    },
                ]
            },
            {
                path: "adjustments",
                component: () => import("../views/inventory/adjustments"),
                children: [
                    {
                        path: "list", component: AdjustmentsList,
                    },
                    {
                        path: "purchase-returns", component: PurchaseReturnsList,
                    },
                    {
                        path: "transfer-returns", component: TransferReturnsList,
                    },
                ]
            },
            {
                path: "site-information",
                component: () => import("../views/inventory/site-information"),
                children: [
                    {
                        path: "facilities", component: FacilitiesList,
                    },
                    {
                        path: "stores", component: StoresList,
                    },
                    {
                        path: "shelves", component: ShelvesList,
                    },
                ]
            },
            {
                path: "reports",
                component: () => import("../views/inventory/reports"),
                children: [
                    {
                        path: "general-reports", component: GeneralReportsList,
                    },
                    {
                        path: "inventory-reports", component: InventoryReportsList,
                    },
                ]
            },
            {
                path: "settings",
                component: () => import("../views/inventory/settings"),
                children: [
                    {
                        path: "general-settings", component: GeneralSettings,
                    },
                    {
                        path: "approval-process", component: ApprovalProcess,
                    },
                    {
                        path: "email-templates", component: EmailTemplates,
                    },
                    {
                        path: "prefixes", component: Prefixes,
                    },
                    {
                        path: "e-sign", component: ESign,
                    },
                    {
                        path: "misc", component: Misc,
                    },
                ]
            },
        ],
    },
];
